export const isDesktopMediumViewPort = (width: number) => width < 990;
